import React, { useEffect, useMemo, useState } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useRecapitulationReportUIContext } from "../../RecapitulationReportUIContext";
import { initialFilter } from "../../RecapitulationReportUIHelpers";
import AsyncSelect from "react-select/async";
import { genOptionLoaderParams } from "../../../../../../../_metronic/_helpers/fetchUtils";
import { findorganization } from "../../../../_redux/organization/organizationCrud";
import { getProgram, getProject } from "../../../../_redux/recapitulation-report/recapitulationReportCrud";

const prepareFilter = (queryParams, values) => {
  const { date, organization_uuid, fund_type, program_uuid, project_uuid } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};

  //add to Object filter
  filter.organization_uuid = organization_uuid ?? "";
  filter.date = date ?? "";
  filter.fund_type = fund_type ?? "";
  filter.program_uuid = program_uuid ?? "";
  filter.project_uuid = project_uuid ?? "";
  newQueryParams.filter = filter;
  return newQueryParams;
};

export const RecapitulationReportFilter = ({ listLoading }) => {
  // ConsolidationReport UI Context
  const recapitulationReportUIContext = useRecapitulationReportUIContext();
  const recapitulationReportUIProps = useMemo(() => {
    return {
      setQueryParams: recapitulationReportUIContext.setQueryParams,
      queryParams: recapitulationReportUIContext.queryParams,
      filterType: recapitulationReportUIContext.filterType
    };
  }, [recapitulationReportUIContext]);

  const [defaultOptions, setDefaultOptions] = useState({
    organizations: [],
    projects: [],
    programs: [],
    fundtypes: [
      {label:"ZAKAT", value: "ZAKAT"}, 
      {label:  "INFAK", value: "INFAK"}, 
      {label:"SEDEKAH", value: "SEDEKAH"}
    ]
  });

  const findProgram = async (value) => {
    const result = await getProgram(value);

    if (result.data) {
      const { data } = result.data;
      const options = data.map(item => ({
        label: item.name,
        value: item.uuid
      }))
      setDefaultOptions(prev => ({
        ...prev,
        programs: options
      }));
    }
  }

  const findProject = async (program_uuid) => {
    const result = await getProject(program_uuid);

    if (result.data) {
      const { data } = result.data;
      const options = data.map(item => ({
        label: item.name,
        value: item.uuid
      }))
      setDefaultOptions(prev => ({
        ...prev,
        projects: options
      }));
    }
  };

  useEffect(() => {
    findorganization({
      pageNumber: 1,
      pageSize: 10,
      filter: {}
    }).then(res => {
      const { data } = res.data;
      const options = data.items.map(item => ({
        label: item.name,
        value: item.uuid
      }));
      setDefaultOptions(prev => ({
        ...prev,
        organizations: options
      }));
    });
  }, []);

  const applyFilter = values => {
    const newQueryParams = prepareFilter(
      recapitulationReportUIProps.queryParams,
      values
    );
    
    if (!isEqual(newQueryParams, recapitulationReportUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      recapitulationReportUIProps.setQueryParams(newQueryParams);
    }
  };

  const [currentTimeout, setCurrentTimeout] = useState(null);


  return (
    <Formik
      initialValues={initialFilter.filter}
      onSubmit={values => {
        applyFilter(values);
      }}
    >
      {({ values, handleSubmit, handleBlur, setFieldValue }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-3">
              <label htmlFor="name">Organisasi</label>
              <AsyncSelect
                name="organization_uuid"
                defaultOptions={defaultOptions.organizations}
                loadOptions={genOptionLoaderParams(
                  inputValue =>
                    findorganization({
                      page1umber: 1,
                      pageSize: 50,
                      filter: { name: inputValue }
                    }),
                  ({ name, uuid }) => ({
                    label: name ?? "",
                    value: uuid ?? ""
                  }),
                  currentTimeout,
                  setCurrentTimeout
                )}
                isClearable
                onChange={e => {
                  const value = e && e.value;
                  if (value) {
                    setFieldValue("organization_uuid", value);
                  } else {
                    setFieldValue("organization_uuid", "");
                  }
                }}
              />
            </div>
            <div className="col-lg-3">
              <label>
                <strong>Pilih Tanggal Transaksi</strong>
              </label>
              <input
                className="form-control"
                type="date"
                name="date"
                onChange={e => {
                  setFieldValue(e.target.name, e.target.value);
                }}
                onBlur={handleBlur}
              />
            </div>
            <div className="col-lg-3">
              <label htmlFor="name">Jenis Dana</label>
              <AsyncSelect
                name="fund_type"
                defaultOptions={defaultOptions.fundtypes}
                isClearable
                onChange={e => {
                  const value = e && e.value;
                  if (value) {
                    setFieldValue("fund_type", value);

                    if (values.organization_uuid) {
                      // get to backend
                      findProgram({"fund_type": value, "organization_uuid": values.organization_uuid});
                      return;
                    }

                    // get to backend
                    findProgram({"fund_type": value});
                    
                  } else {
                    setFieldValue();
                  }
                }}
              />
            </div>
            <div className="col-lg-3" hidden={!values.fund_type}>
              <label htmlFor="name">Program</label>
              <AsyncSelect
                name="organization_uuid"
                defaultOptions={defaultOptions.programs}
                isClearable
                onChange={e => {
                  const value = e && e.value;
                  if (value) {
                    setFieldValue("program_uuid", value);

                    findProject({"program_uuid": value})
                  } else {
                    setFieldValue("program_uuid", "");
                  }
                }}
              />
            </div>
            <div className="col-lg-3 mt-5" hidden={!values.program_uuid}>
              <label htmlFor="name">Project</label>
              <AsyncSelect
                name="organization_uuid"
                defaultOptions={defaultOptions.projects}
                isClearable
                onChange={e => {
                  const value = e && e.value;
                  if (value) {
                    setFieldValue("project_uuid", value);
                  } else {
                    setFieldValue("project_uuid", "");
                  }
                }}
              />
            </div>
            {/* <div className="col-lg-4">
              <label>
                <strong>Pilih Bulan</strong>
              </label>
              <Select
                name="month"
                onChange={e => {
                  setFieldValue(e.target.name, e.target.value);
                }}
                onBlur={handleBlur}
              >
                <option value={""}>-</option>

                {months.map(month => (
                  <option key={month} value={month.value}>
                    {month.label.toUpperCase()}
                  </option>
                ))}
              </Select>
            </div> */}
          </div>
          <div className="form-group row">
            <div className="col">
              <button
                className="btn btn-warning float-right"
                onClick={handleSubmit}
              >
                Terapkan
              </button>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};
